import { DataRepository, DownloadProvider } from "../domain/interfaces";

export class MemoryDataRepository
  implements DataRepository
{
  data = undefined;
  constructor(data) {
    this.data = data;
  }
  get_data() {
    return this.data
  }
}



export class MemoryDownloadProvider
  implements DownloadProvider
{
  downloaded = undefined;
  constructor() {
  }
  
  download(content) {
    this.downloaded = content
  }
  
}